import React, { useContext, useMemo, useRef } from 'react';
import OutdoorMap from './OutdoorMap';
import IndoorMap from './IndoorMap';
import { WalkDataContext } from '../hooks/walkDataContext';

const MapPopup = React.memo(({ handleTrack, currentTrackSlug, paths }) => {
  const { language, storyMetas, tracks, contentState } = useContext(WalkDataContext);
  
  // Ref für Previous Values um unnecessary re-calculations zu vermeiden
  const prevActiveTracksRef = useRef([]);
  const prevContentStateRef = useRef([]);
  
  // Memoize mapImageUrl
  const mapImageUrl = useMemo(() => 
    storyMetas?.storyMeta_mapimage?.[1] || null,
    [storyMetas]
  );
  
  // Ultra-optimierte activeTracks Berechnung
  const activeTracks = useMemo(() => {
    if (!tracks || !contentState) return [];
    
    // Quick shallow comparison - wenn sich contentState nicht geändert hat
    if (contentState === prevContentStateRef.current) {
      return prevActiveTracksRef.current;
    }
    
    const result = tracks.filter(track => {
      // Früher Return für bessere Performance
      if (track.metadata?.trackMeta_radio?.[1]) return false;
      
      const contentStateEntry = contentState.find(item => item.slug === track.slug);
      return contentStateEntry && contentStateEntry.state === 'active';
    });
    
    // Cache für nächsten Render
    prevActiveTracksRef.current = result;
    prevContentStateRef.current = contentState;
    
    return result;
  }, [tracks, contentState]);

  // Memoize Map-Props separat
  const mapProps = useMemo(() => ({
    tracks: activeTracks,
    handleTrack,
    currentTrackSlug,
    paths,
    language,
    metas: storyMetas
  }), [activeTracks, handleTrack, currentTrackSlug, paths, language, storyMetas]);

  // Conditional rendering mit memoization
  if (mapImageUrl) {
    return (
      <IndoorMap
        {...mapProps}
        imageUrl={mapImageUrl}
      />
    );
  }
  
  return (
    <OutdoorMap
      {...mapProps}
    />
  );
}, (prevProps, nextProps) => {
  // Strenge Prop-Vergleiche
  return prevProps.handleTrack === nextProps.handleTrack &&
         prevProps.currentTrackSlug === nextProps.currentTrackSlug &&
         prevProps.paths === nextProps.paths;
});

export default MapPopup;